import { motion } from "framer-motion";
import { Diamond } from "@/components/decor";

export const MOTION = { duration: 0.24, ease: "easeOut" };

export function Reveal({ children, delay = 0, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ ...MOTION, delay }}
    >
      {children}
    </motion.div>
  );
}

export function SectionHead({ eyebrow, title, dark = false, className = "", children }) {
  return (
    <div className={className}>
      {eyebrow && (
        <Reveal>
          <div className="flex items-center gap-3">
            <Diamond className="bg-signal" />
            <span className={`text-label uppercase ${dark ? "text-white/60" : "text-accent/70"}`}>
              {eyebrow}
            </span>
          </div>
        </Reveal>
      )}
      <Reveal delay={0.05}>
        <h2
          className={`mt-5 text-balance font-display text-h2-sm font-semibold tracking-tight md:text-h2 ${
            dark ? "text-white" : "text-ink"
          }`}
        >
          {title}
        </h2>
      </Reveal>
      {children}
    </div>
  );
}
